/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Capture_Hint_BarefootInputs */

const en_us2_body_assessment_capture_hint_barefoot = /** @type {(inputs: Body_Assessment_Capture_Hint_BarefootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barefoot, with both feet on the floor.`)
};

const pt_br2_body_assessment_capture_hint_barefoot = /** @type {(inputs: Body_Assessment_Capture_Hint_BarefootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descalço, com os dois pés no chão.`)
};

const es_419_body_assessment_capture_hint_barefoot = /** @type {(inputs: Body_Assessment_Capture_Hint_BarefootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin zapatos, con los dos pies en el suelo.`)
};

const pt_pt2_body_assessment_capture_hint_barefoot = /** @type {(inputs: Body_Assessment_Capture_Hint_BarefootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descalço, com os dois pés no chão.`)
};

const fr_fr2_body_assessment_capture_hint_barefoot = /** @type {(inputs: Body_Assessment_Capture_Hint_BarefootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pieds nus, les deux pieds au sol.`)
};

const de_de2_body_assessment_capture_hint_barefoot = /** @type {(inputs: Body_Assessment_Capture_Hint_BarefootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barfuß, mit beiden Füßen auf dem Boden.`)
};

const it_it2_body_assessment_capture_hint_barefoot = /** @type {(inputs: Body_Assessment_Capture_Hint_BarefootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A piedi nudi, con entrambi i piedi a terra.`)
};

/**
* | output |
* | --- |
* | "Barefoot, with both feet on the floor." |
*
* @param {Body_Assessment_Capture_Hint_BarefootInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_capture_hint_barefoot = /** @type {((inputs?: Body_Assessment_Capture_Hint_BarefootInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Capture_Hint_BarefootInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_capture_hint_barefoot(inputs)
	if (locale === "es-419") return es_419_body_assessment_capture_hint_barefoot(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_capture_hint_barefoot(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_capture_hint_barefoot(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_capture_hint_barefoot(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_capture_hint_barefoot(inputs)
	return en_us2_body_assessment_capture_hint_barefoot(inputs)
});
export { body_assessment_capture_hint_barefoot as "body-assessment.capture_hint_barefoot" }